import React, { useState } from "react";
import { Link } from "react-router-dom";

const ProductList = () => {
  // Product Data
  const products = [
    {
      id: 1,
      name: "Anadrol",
      category: "TABLETS",
      image: "assets/images/Olympia_IMG/Anadrol-Tab.png",
    },
    {
      id: 2,
      name: "ANAVAR-10",
      category: "TABLETS",
      image: "assets/images/Olympia_IMG/Anavar-Tab.png",
    },
    {
      id: 3,
      name: "CLEN",
      category: "TABLETS",
      image: "assets/images/Olympia_IMG/Clen-Tab.png",
    },
    {
      id: 4,
      name: "Dianabol",
      category: "TABLETS",
      image: "assets/images/Olympia_IMG/Dianabol_Tab.png",
    },
    {
      id: 5,
      name: "STANA-10",
      category: "TABLETS",
      image: "assets/images/Olympia_IMG/Stana-Tab.png",
    },
    {
      id: 6,
      name: "T3-50",
      category: "TABLETS",
      image: "assets/images/Olympia_IMG/T-Tab.png",
    },
    {
      id: 7,
      name: "BULK",
      category: "INJECTABLES",
      image: "assets/images/Olympia_IMG/Inject-BULK.png",
    },
    {
      id: 8,
      name: "CUT",
      category: "INJECTABLES",
      image: "assets/images/Olympia_IMG/Inject-CUT.png",
    },
    {
      id: 9,
      name: "EQ",
      category: "INJECTABLES",
      image: "assets/images/Olympia_IMG/Inject-EQ.png",
    },
    {
      id: 10,
      name: "Primabolan",
      category: "INJECTABLES",
      image: "assets/images/Olympia_IMG/Inject-Primabolan.png",
    },
    {
      id: 11,
      name: "DECA",
      category: "INJECTABLES",
      image: "assets/images/Olympia_IMG/Inject-DECA.png",
    },
    {
      id: 12,
      name: "MasterP",
      category: "INJECTABLES",
      image: "assets/images/Olympia_IMG/Inject-MasterP.png",
    },
    {
      id: 13,
      name: "Sustanon",
      category: "INJECTABLES",
      image: "assets/images/Olympia_IMG/Inject-Sustanon.png",
    },
    {
      id: 14,
      name: "TestC",
      category: "INJECTABLES",
      image: "assets/images/Olympia_IMG/Inject-TestC.png",
    },
    {
      id: 15,
      name: "TestE",
      category: "INJECTABLES",
      image: "assets/images/Olympia_IMG/Inject-TestE.png",
    },
    {
      id: 16,
      name: "TestP",
      category: "INJECTABLES",
      image: "assets/images/Olympia_IMG/Inject-TestP.png",
    },
    {
      id: 17,
      name: "TREN_A",
      category: "INJECTABLES",
      image: "assets/images/Olympia_IMG/Inject-TREN_A.png",
    },
    {
      id: 18,
      name: "TREN_H",
      category: "INJECTABLES",
      image: "assets/images/Olympia_IMG/Inject-TREN_H.png",
    },
    {
      id: 19,
      name: "TREN_MIX",
      category: "INJECTABLES",
      image: "assets/images/Olympia_IMG/Inject-TREN_MIX.png",
    },
    {
      id: 20,
      name: "TrenE",
      category: "INJECTABLES",
      image: "assets/images/Olympia_IMG/Inject-TrenE.png",
    },
    {
      id: 21,
      name: "WINSTROL",
      category: "INJECTABLES",
      image: "assets/images/Olympia_IMG/Inject-WINSTROL.png",
    },
    {
      id: 22,
      name: "FRAG",
      category: "PEPTIDES",
      image: "assets/images/Olympia_IMG/Peptides-FRAG.png",
    },
    {
      id: 23,
      name: "GRP6",
      category: "PEPTIDES",
      image: "assets/images/Olympia_IMG/Peptides-GRP6.png",
    },
    {
      id: 24,
      name: "HGH",
      category: "PEPTIDES",
      image: "assets/images/Olympia_IMG/Peptides-HGH.png",
    },
    {
      id: 25,
      name: "IGF",
      category: "PEPTIDES",
      image: "assets/images/Olympia_IMG/Peptides-IGF.png",
    },
  ];

  // Local state for selected category (tab functionality)
  const [selectedCategory, setSelectedCategory] = useState("ALL");

  // Filter products based on state
  const filteredProducts =
    selectedCategory === "ALL"
      ? products
      : products.filter((p) => p.category === selectedCategory);

  // Handler for category clicks
  const handleCategoryClick = (category) => {
    setSelectedCategory(category);
  };

  return (
    <>
      {/* TOP BAR */}
      <section
        className="page-title"
        style={{
          backgroundImage: "url(/assets/images/bg/02.jpg)",
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <div className="container">
          <div className="row">
            <div className="col-lg-6">
              <h1>Product Grid</h1>
              <nav aria-label="breadcrumb" className="page-breadcrumb">
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="/">
                      <i className="bi bi-house-door me-1"></i>Home
                    </Link>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Product Grid
                  </li>
                </ol>
              </nav>
            </div>
          </div>
        </div>
        <div id="particles-js"></div>
      </section>

      {/* PAGE CONTENT */}
      <div className="page-content">
        <div className="container mt-5">
          <div className="row mb-5">
            <div className="col">
              <div className="border border-light rounded p-3">
                <div className="row align-items-center">
                  <div className="col-md-5 mb-3 mb-md-0">
                    <span>
                      Showing {filteredProducts.length} of {products.length} total
                    </span>
                  </div>
                  <div className="col-md-7 d-flex align-items-center justify-content-md-end">
                    <div className="sort-filter ms-3 d-flex align-items-center">
                      <select className="form-select">
                        <option defaultValue>Sort By</option>
                        <option value="1">Newest Item</option>
                        <option value="2">Popular</option>
                        <option value="3">Best Match</option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="row">
            {/* PRODUCTS LIST */}
            <div className="col-lg-10 col-md-12 order-lg-1 ps-lg-5">
              <div className="row text-center">
                {filteredProducts.map((product) => (
                  <div key={product.id} className="col-lg-4 col-md-6 mt-4">
                    <div className="product-item">
                      <div className="product-img">
                        <Link to={`/product/${product.id}`}>
                          <img
                            className="img-fluid"
                            src={product.image}
                            alt={product.name}
                          />
                        </Link>
                      </div>
                      <div className="product-desc">
                        <Link
                          to={`/product/${product.id}`}
                          className="product-name"
                        >
                          {product.name}
                        </Link>
                      </div>
                    </div>
                  </div>
                ))}
              </div>

              {/* PAGINATION */}
              <nav aria-label="Page navigation" className="mt-8 text-center">
                <ul className="pagination">
                  <li className="page-item">
                    <a className="page-link" href="#">
                      <i className="bi bi-arrow-left"></i>
                    </a>
                  </li>
                  <li className="page-item active">
                    <a className="page-link" href="#">
                      1
                    </a>
                  </li>
                  <li className="page-item">
                    <a className="page-link" href="#">
                      2
                    </a>
                  </li>
                  <li className="page-item">
                    <a className="page-link" href="#">
                      3
                    </a>
                  </li>
                  <li className="page-item">
                    <a className="page-link" href="#">
                      <i className="bi bi-arrow-right"></i>
                    </a>
                  </li>
                </ul>
              </nav>
            </div>

            {/* SIDEBAR */}
            <div className="col-lg-2 col-md-12 mt-8 mt-lg-0">
              <div className="themeht-sidebar">
                <div className="widget widget-categories">
                  <h4 className="widget-title">Categories</h4>
                  <ul className="widget-categories list-unstyled">
                    <li>
                      <button
                        onClick={() => handleCategoryClick("ALL")}
                        className={`border-0 bg-transparent text-start w-100 p-2 ${
                          selectedCategory === "ALL" ? "active" : ""
                        }`}
                      >
                        <i className="bi bi-chevron-right me-1"></i> ALL
                      </button>
                    </li>
                    <li>
                      <button
                        onClick={() => handleCategoryClick("TABLETS")}
                        className={`border-0 bg-transparent text-start w-100 p-2 ${
                          selectedCategory === "TABLETS" ? "active" : ""
                        }`}
                      >
                        <i className="bi bi-chevron-right me-1"></i> TABLETS
                      </button>
                    </li>
                    <li>
                      <button
                        onClick={() => handleCategoryClick("INJECTABLES")}
                        className={`border-0 bg-transparent text-start w-100 p-2 ${
                          selectedCategory === "INJECTABLES" ? "active" : ""
                        }`}
                      >
                        <i className="bi bi-chevron-right me-1"></i> INJECTABLES
                      </button>
                    </li>
                    <li>
                      <button
                        onClick={() => handleCategoryClick("PEPTIDES")}
                        className={`border-0 bg-transparent text-start w-100 p-2 ${
                          selectedCategory === "PEPTIDES" ? "active" : ""
                        }`}
                      >
                        <i className="bi bi-chevron-right me-1"></i> PEPTIDES
                      </button>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ProductList;